import React from 'react'
import PropTypes from 'prop-types'

import Select from 'react-select'

const Form = props => (
  <form
    className="form-horizontal"
    role="form"
    onSubmit={props.editCountryTax(props.data)}
  >
    <div className="portlet light">
      <div className="portlet-title">
        <div className="caption">
          <span className="caption-subject bold uppercase">Edit a country tax</span>
        </div>
      </div>
      <div className="portlet-body">
        <div className="form-body">
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              GC Country
            </label>
            <div className="col-md-9">
              <Select
                name="gcCountry"
                placeholder="Choose GC country"
                options={props.countrySelections}
                value={props.data.gcCountry}
                onChange={props.handleCountryChange('gcCountry', props.data)}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              VAT (%)
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="vat"
                value={props.data.vat}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              WHT (%)
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="wht"
                value={props.data.wht}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              WHT with TIN (%)
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="whtTin"
                value={props.data.whtTin}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              GC Commission Fee (%)
            </label>
            <div className="col-md-9">
              <input
                type="number"
                className="form-control"
                name="gcCommissionFee"
                value={props.data.gcCommissionFee}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Processing Fee (%)
            </label>
            <div className="col-md-9">
              <input
                type="number"
                className="form-control"
                name="processingFee"
                value={props.data.processingFee}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Company Legal Name
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="companyLegalName"
                value={props.data.companyLegalName}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Tax Number
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="taxNumber"
                value={props.data.taxNumber}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Address
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="address"
                value={props.data.address}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Bank
            </label>
            <div className="col-md-9">
              <Select
                name="bank"
                placeholder="Choose bank"
                options={props.bankSelections}
                value={props.data.bank}
                onChange={props.handleCountryChange('bank', props.data)}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Account Number
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="accountNumber"
                value={props.data.accountNumber}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Account Name
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="accountName"
                value={props.data.accountName}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="name" className="col-md-3 control-label">
              Swift Code
            </label>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter text"
                name="swiftCode"
                value={props.data.swiftCode}
                onChange={props.handleFormChange(props.data)}
              />
            </div>
          </div>
          <div className="form-actions">
            <div className="row">
              <div className="col-md-offset-3 col-md-9">
                <button type="submit" className="btn btn-lg btn-primary">Submit</button>
                <button
                  type="button"
                  className="btn btn-lg default"
                  onClick={props.handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
)

Form.defaultProps = {
  data: {
    isDefault: false,
  },
}

Form.propTypes = {
  data: PropTypes.shape({
    gcCountry: PropTypes.string.isRequired,
    vat: PropTypes.number.isRequired,
    wht: PropTypes.number.isRequired,
    whtTin: PropTypes.number.isRequired,
    bank: PropTypes.string.isRequired,
    companyLegalName: PropTypes.string.isRequired,
    taxNumber: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    accountNumber: PropTypes.string.isRequired,
    accountName: PropTypes.string.isRequired,
    swiftCode: PropTypes.string.isRequired,
    gcCommissionFee: PropTypes.number,
    processingFee: PropTypes.number,
  }).isRequired,
  countrySelections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  bankSelections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  editCountryTax: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  handleCountryChange: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
}

export default Form
